import React, { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map, omit, size, values } from 'lodash-es'
import PropTypes from 'prop-types'

import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'

import { DEFAULT_PAGE } from '../../../../common/constants'

import { MENU_FORMATS } from '../../../constants'
import { isOnlyHTMLFormat } from '../../../helpers'

const MenuFormatFilter = ({ disabled, excludedFormats }) => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { menuFormats, isAwaitingScraping, scrapedById } = getQueryParams(
    search,
  )

  const handleChangeMenuFormat = useCallback(
    menuFormats =>
      history.push(
        createUrl(pathname, search, {
          menuFormats,
          scrapedById: isOnlyHTMLFormat(menuFormats) ? scrapedById : '',
          isAwaitingScraping: isOnlyHTMLFormat(menuFormats)
            ? isAwaitingScraping
            : '',
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search, scrapedById, isAwaitingScraping],
  )

  const getMaxTagPlaceholder = useCallback(
    omittedValues => `+ ${size(omittedValues)} more`,
    [],
  )

  const options = useMemo(() => values(omit(MENU_FORMATS, excludedFormats)), [
    excludedFormats,
  ])

  return (
    <Form.Item label="Menu formats">
      <Select
        style={{ width: '100%' }}
        allowClear
        value={menuFormats}
        mode="multiple"
        onChange={handleChangeMenuFormat}
        maxTagCount={1}
        maxTagPlaceholder={getMaxTagPlaceholder}
        disabled={disabled}
      >
        {map(options, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

MenuFormatFilter.propTypes = {
  disabled: PropTypes.bool,
  excludedFormats: PropTypes.arrayOf(PropTypes.string),
}

MenuFormatFilter.defaultProps = {
  disabled: false,
  excludedFormats: [],
}

export default MenuFormatFilter
